// ✅ Login.jsx with API instance
import React, { useState, useEffect } from "react";
import Layout from '../components/layout/Layout';
import API from '../utils/api'; // ✅ Use custom API instance
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [pin, setPin] = useState('');
  const [step, setStep] = useState('login'); // 'login' or 'mfa'
  const [userId, setUserId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) navigate('/');
  }, [navigate]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await API.post('/api/auth/login', formData); // ✅ Use API

      if (res.data.step === 'mfa_required') {
        setStep('mfa');
        setUserId(res.data.userId);
      }
    } catch (err) {
      console.error("❌ Login failed", err);
      setError('Invalid email or password');
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await API.post('/api/auth/verify-mfa', { userId, pin }); // ✅ Use API

      localStorage.setItem('user', JSON.stringify(res.data));
      navigate('/');
    } catch (err) {
      console.error("❌ MFA failed", err);
      setError("Invalid or expired code");
    }
  };

  return (
    <Layout>
      <div className="container py-5">
        <div className="card mx-auto" style={{ maxWidth: "400px" }}>
          <div className="card-header bg-primary text-white text-center">
            <h4>Login to Harmonia</h4>
          </div>
          <div className="card-body">
            {error && <p className="text-danger">{error}</p>}

            {step === 'login' && (
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label>Password</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button className="btn btn-primary w-100" type="submit">Login</button>
                <p className="mt-3 text-center">
                  Don't have an account? <a href="/register">Sign up</a>
                </p>
              </form>
            )}

            {step === 'mfa' && (
              <form onSubmit={handleVerify}>
                <div className="mb-3">
                  <label>Enter the 6-digit code sent to your email</label>
                  <input
                    type="text"
                    className="form-control"
                    value={pin}
                    onChange={(e) => setPin(e.target.value)}
                    required
                  />
                </div>
                <button className="btn btn-success w-100" type="submit">Verify</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
